import type { ComparisonPeriod } from '@webapp/account/src/resources/reports/comparison';
import type { FilterType } from '@webapp/account/src/resources/reports/filter';
import type { BaseReport } from '@webapp/account/src/resources/reports/reports';
import { ReportStatus } from '@webapp/account/src/resources/reports/reports';

import { today } from '@webapp/common/lib/date';

export interface LinkParamFilter {
    paramId: number;
    value: string;
    filterType: FilterType;
    isDisabled?: boolean;
}

export interface IFilterTagReport {
    items: Array<IFilterTag>;
    name: string;
}
export interface IFilterTag {
    text: string;
    type: FilterType;
    comment?: boolean;
}

export interface GlobalFilter {
    dateFrom: string;
    dateTo: string;
    comparePeriods: Array<ComparisonPeriod>;
    basePeriodName?: string; // пользовательское название базового периода
    reportStatus: ReportStatus;
    filters: Array<BaseReport>;
    excludedQuestionIds: Set<number>;
    linkParamsFilters: Array<LinkParamFilter>;
    excludedParamIds: Set<number>;
    tags: Record<number, IFilterTagReport>;
    excludedCrossTabsId: Set<number>;
}

// Даты фильтров исторически приходят из addons/URL и могут быть не примитивом.
// dayjs на таком значении уходит в рекурсию (FRONT-2ACP/2ACY), поэтому
// нормализуем/проверяем их на границе состояния.
export const isFilterDate = (value: unknown): value is string | number | Date =>
    typeof value === 'string' || typeof value === 'number' || value instanceof Date;

export const initialGlobalFilter: Readonly<GlobalFilter> = {
    dateFrom: '1900-01-01',
    dateTo: today,
    comparePeriods: [],
    reportStatus: ReportStatus.ALL,
    filters: [],
    linkParamsFilters: [],
    excludedQuestionIds: new Set([]),
    excludedParamIds: new Set([]),
    tags: {},
    excludedCrossTabsId: new Set([]),
};
